import { render } from "./HomeLiveScoring.vue?vue&type=template&id=48fcb5bd"
import script from "./HomeLiveScoring.vue?vue&type=script&lang=js"
export * from "./HomeLiveScoring.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__